import { useMutation } from "@tanstack/react-query";
import { message } from "antd";
import { interceptor } from "../utils/interceptor";

export const useGenericMutation = ({
    endpoint,
    method = "post",
    body = {},
    onSuccess,
    onError,
    options = {},
}) => {
    const axiosInstance = interceptor();

    const mutationFn = async (payload = body) => {
        const { data } = await axiosInstance({
            url: endpoint,
            method,
            data: payload,
        });
        return data;
    };

    return useMutation({
        mutationFn,
        onSuccess: (data) => {
            if (onSuccess) onSuccess(data);
            else console.log(`Mutation to ${endpoint} success:`, data);
        },
        onError: (error) => {
            console.log(error)
            if (onError) {
                onError(error);
                return; // ✅ Prevent React from showing overlay
            }
            if (Array.isArray(error.response?.data?.errors)) {
                error.response.data.errors.forEach(error => {
                    message.error(error.message);
                });
                return
            }
            if (error.response?.data?.message) {
                message.error(error.response.data.message);
                return
            }
            if (error.response?.data?.error) {
                message.error(error.response.data.error);
                return
            }
            message.error("Something went wrong");
        },
        ...options,
    });
};
